import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingTheme } from '../types/setting-theme-type';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SettingThemeService {
    constructor(private _httpClient: HttpClient) { }

    getSettingTheme(): Observable<SettingTheme> {
        return this._httpClient.get<SettingTheme>(`api/setting-themes`);
    }
}
